import * as React from "react";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import { Helmet } from "react-helmet";
import { withToastManager } from "react-toast-notifications";

/** Presentation/UI */
import Table from "../../Components/Table";
import BackendWrapper from "../../Components/Layouts/BackendWrapper";
import PageLoader from "../../Components/PageLoader";
import {
  TableHeader,
  TableHeaderContainer
} from "../../Components/Styled/ListViewElements";
import Row from "../../Components/Styled/Row";
import StyledButton from "../../Components/Styled/Button";
import { MdSearch } from "react-icons/md";
import { Colors } from "../../Themes";

/** Custom Types */
import { ToastNotificationType } from "../../CustomTypes";
import { TableConsts } from "src/Utils/Consts";
import { listTransactions } from "src/graphql/queries";

type Props = {
  toastManager: ToastNotificationType;
};

type State = {
  importModal: boolean;
  searchFilter: boolean;
};

class Sales extends React.Component<Props> {
  state: State = {
    importModal: false,
    searchFilter: false
  };

  // Toggle the searcch filter
  toggleSearchFilter = (): void => {
    this.setState({ searchFilter: !this.state.searchFilter });
  };

  /** Success notification */
  toastNotification = (message: string, appearance?: string) => {
    this.props.toastManager.add(message, {
      appearance: appearance ? appearance : "success",
      autoDismiss: true
    });
  };

  render() {
    const { searchFilter } = this.state;

    return (
      <BackendWrapper>
        <Query
          query={gql(listTransactions)}
          variables={{
            limit: TableConsts.limit
          }}
        >
          {({ loading, error, data }) => {
            if (loading) {
              return <PageLoader />;
            }

            if (error) {
              return <div>There was a problem loading your data</div>;
            }

            if (!data || !data.listTransactions) {
              return <Row>There are no Reports at the moment</Row>;
            }

            return (
              <React.Fragment>
                <TableHeaderContainer>
                  <TableHeader>
                    <span>Transactions History</span>
                  </TableHeader>
                  <StyledButton
                    type="button"
                    label={<MdSearch size="1.3em" color={Colors.secondary} />}
                    width="auto"
                    margin="0px 10px"
                    onClick={this.toggleSearchFilter}
                    color={searchFilter ? Colors.background : Colors.coal}
                    background={
                      searchFilter ? Colors.default : Colors.background
                    }
                  />
                </TableHeaderContainer>
                <Table
                  data={data.transactions}
                  columns={[
                    {
                      Header: "Report Name",
                      accessor: "name",
                      sortable: true,
                      filterable: searchFilter
                    },
                    {
                      Header: "Purchase Date",
                      accessor: "purchaseDate",
                      sortable: false
                    },
                    {
                      Header: "Company",
                      accessor: "company",
                      sortable: true,
                      filterable: searchFilter
                    },
                    {
                      Header: "Price",
                      accessor: "price",
                      sortable: true
                    }
                  ]}
                  defaultPageSize={TableConsts.defaultRows}
                  showPaginationBottom={
                    data.listTransactions.items.length > TableConsts.defaultRows
                  }
                />
              </React.Fragment>
            );
          }}
        </Query>
        <Helmet title="View Purchased Reports" />
      </BackendWrapper>
    );
  }
}

export default withToastManager(Sales);



// WEBPACK FOOTER //
// ./src/Containers/Sales/index.tsx